module.exports = __webpack_public_path__ + "static/scale-model-of-chazen-museum-of-art-in-madison-wisconsin-096c7fb6f5d1a4809ac7955c71ff9b24.png";